export const chapterHeadConfig = {
  sidebarNav: [
    {
      title: "Home",
      href: "/chapter/overview",
      icon: "layout-dashboard",
    },
    {
      title: "Mahallu",
      href: "/chapter/mahallu",
      icon: "users",
    },
    {
      title: "Sponsorships",
      href: "/chapter/sponsorships",
      icon: "heart",
    },
    {
      title: "Payments",
      href: "/chapter/payments",
      icon: "receipt",
    },
    {
      title: "Profile",
      href: "/chapter/settings",
      icon: "user-circle",
    },
  ],
};
